import { render, staticRenderFns } from "./fengrenbiao.vue?vue&type=template&id=12cbcff2&scoped=true&"
import script from "./fengrenbiao.vue?vue&type=script&lang=js&"
export * from "./fengrenbiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbcff2",
  null
  
)

export default component.exports